import { AmbientOcclusionFeature } from '@kb3d/models/classes';
import { AmbientOcclusionHelper } from '@kb3d/view/helpers/ambient-occlusion-helper';
import { SubmeshVertexData } from '@kb3d/view/helpers/geometry-helper';
import { FeatureGeometryProcessor, ProcessorData } from './base-processor';

export class AmbientOcclusionGeometryProcessor extends FeatureGeometryProcessor<AmbientOcclusionFeature> {
    aoHelper = new AmbientOcclusionHelper();
    updateMeshGeometry(
        feature: AmbientOcclusionFeature,
        vertexData: SubmeshVertexData,
        vertexDataChanges: Partial<SubmeshVertexData>,
        dependencyData: ProcessorData<never>
    ) {
        const newVertexData = super.updateMeshGeometry(feature, vertexData, vertexDataChanges, dependencyData);

        //aoHelper.applyRayBasedAO(thisMesh, this.scene);
        const colors = this.aoHelper.applyGeometryBasedAO(newVertexData, {
            radius: feature.radius,
            maxDarken: feature.maxDarken,
            sampleStep: feature.sampleStep,
            neighborThreshold: feature.neighborThreshold,
            includeSelfOcclusion: feature.includeSelfOcclusion,
        });
        if (colors) {
            newVertexData.colors = colors;
        }

        return newVertexData;
    }
}
